const StringFunctions = {

    format: (string, ...params) => {
        return string.replace(/{(\d+)}/g, function(match, number) {
            return typeof params[number] != 'undefined'
              ? params[number]
              : match;
          });
    },

    normalizeBoxIdentifier: (identifier) => {
        if (!identifier) return identifier;
        return identifier.replace(/\s+/g, '');
    }
};

export default StringFunctions